var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.727,
    height: 33.117,
    viewBox: "0 0 23.727 33.117",
    className: "arrow-1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(-84.318 -403.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M-19654.2,4127.549s-21.754,18.755,4.428,25.125",
    transform: "translate(19748 -3723.087)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_6",
    "data-name": "Polygon 6",
    transform: "translate(108.045 427.55) rotate(112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.300490379333496 8.499997138977051 L 1.699509978294373 8.499997138977051 C 1.441439986228943 8.499997138977051 1.312180042266846 8.327656745910645 1.268579959869385 8.253556251525879 C 1.224979996681213 8.179466247558594 1.137109994888306 7.982776641845703 1.262439966201782 7.757176876068115 L 4.562920093536377 1.816306710243225 C 4.691880226135254 1.584186673164368 4.911540031433105 1.559126734733582 5 1.559126734733582 C 5.088459968566895 1.559126734733582 5.308119773864746 1.584186673164368 5.437079906463623 1.816306710243225 L 8.737560272216797 7.757176876068115 C 8.862890243530273 7.982776641845703 8.775019645690918 8.179466247558594 8.731419563293457 8.253556251525879 C 8.687820434570312 8.327656745910645 8.558560371398926 8.499997138977051 8.300490379333496 8.499997138977051 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 2.059126853942871 L 1.699509620666504 7.999996662139893 L 8.300479888916016 7.999996662139893 L 5.000010013580322 2.059136867523193 C 5.000008106231689 2.059133529663086 5.000006198883057 2.059130191802979 5.000004291534424 2.059126853942871 C 5.000002861022949 2.059126853942871 5.000001430511475 2.059126853942871 5 2.059126853942871 M 5 1.059128761291504 C 5.341827392578125 1.059128761291504 5.68365478515625 1.230581283569336 5.874159812927246 1.573486328125 L 9.174639701843262 7.51435661315918 C 9.544939994812012 8.180887222290039 9.062970161437988 8.999996185302734 8.300490379333496 8.999996185302734 L 1.699509620666504 8.999996185302734 C 0.9370298385620117 8.999996185302734 0.4550600051879883 8.180887222290039 0.8253602981567383 7.51435661315918 L 4.125840187072754 1.573486328125 C 4.31634521484375 1.230581283569336 4.658172607421875 1.059128761291504 5 1.059128761291504 Z",
    stroke: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow-1.6878b88f.svg";
export { ForwardRef as ReactComponent };